import { TimeSlotsResponse } from '../models/time-slots-response';
import globalAxios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { mergeHeaders, AxiosHeaders } from '../utilities/merge-headers';

export class TimeslotsApi {
    private baseUrl: string;

    public constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    public async get(headers?: AxiosHeaders): Promise<AxiosResponse<TimeSlotsResponse>> {
        const request = {
            url: this.baseUrl + '/timeslots',
            method: 'GET',
            responseType: 'json',
        } as AxiosRequestConfig;

        request.headers = mergeHeaders(request.headers, headers);


        const response = await globalAxios.request<TimeSlotsResponse>(request);
        

        return response;
    }
}